// Módulo de Horas — /operacional/horas
//
// A semana da própria pessoa (todo mundo) e, para quem cuida dela, a lista de
// atividades da empresa. O placar da equipe saiu daqui em 01/10/2026: virou o
// painel "Horas da equipe" do Administrativo (pages/administrativo-horas), que
// também abre a semana de outra pessoa.
import { useState } from 'react';
import { Button, Card, Tabs, Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { usePerms } from '../../hooks/usePerms';
import MinhaSemana from './MinhaSemana';
import AtividadesLista from './AtividadesLista';

const { Title, Text } = Typography;

export default function Horas() {
  const { pode } = usePerms();
  const navigate = useNavigate();
  const veEquipe = pode('horas.ver_equipe') || pode('admin.permissoes.editar');
  // A lista de atividades da empresa: o servidor exige horas.admin para mexer.
  const cuidaDaLista = pode('horas.admin');
  const [aba, setAba] = useState('minha');

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <Title level={4} style={{ marginTop: 0 }}>⏱️ Horas</Title>
          <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
            Anote onde seu tempo foi. É isso que diz quanto cada contrato custou de verdade.
          </Text>
        </div>
        {veEquipe && (
          <Button icon={<TeamOutlined />} onClick={() => navigate('/administrativo/horas')}>Horas da equipe</Button>
        )}
      </div>
      <Card styles={{ body: { paddingTop: 8 } }}>
        {cuidaDaLista ? (
          <Tabs
            activeKey={aba} onChange={setAba}
            items={[
              { key: 'minha', label: 'Minha semana', children: <MinhaSemana /> },
              { key: 'atividades', label: 'Atividades', children: <AtividadesLista /> },
            ]}
          />
        ) : <MinhaSemana />}
      </Card>
    </div>
  );
}
